import { supabase } from "@/integrations/supabase/client";

// Default branch name to use when none is found
const DEFAULT_BRANCH_NAME = "Main Branch";

export const getBranchName = async (userId: string): Promise<string> => {
  try {
    const { data, error } = await supabase.rpc("get_branch_name", {
      p_user_id: userId,
    });

    return data || DEFAULT_BRANCH_NAME;
  } catch (error) {
    console.error("Error in getBranchName:", error);
    return DEFAULT_BRANCH_NAME;
  }
};
/**
 * Get the branch name for a specific repair
 * @param repairId The repair ID
 * @returns The branch name (always returns a string, using default if needed)
 */
export const getBranchNameForRepair = async (
  repairId: string
): Promise<string> => {
  try {
    console.log(`Fetching branch name for repair ${repairId}`);

    // First, get the repair details to find the user who created it
    const { data: repair, error: repairError } = await supabase
      .from("repairs")
      .select("user_id")
      .eq("id", repairId)
      .single();

    if (repairError) {
      console.error("Error fetching repair:", repairError);
      return DEFAULT_BRANCH_NAME;
    }

    if (!repair) {
      console.error(`Repair not found: ${repairId}`);
      return DEFAULT_BRANCH_NAME;
    }

    console.log(`Repair created by user ${repair.user_id}`);

    // Get the branch name using the regular approach
    return getBranchName(repair.user_id);
  } catch (error) {
    console.error("Error in getBranchNameForRepair:", error);
    return DEFAULT_BRANCH_NAME;
  }
};
